import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ACCESS_KEY = "sg_access_token";
const REFRESH_KEY = "sg_refresh_token";

export const getAccessToken = () => {
  try { return localStorage.getItem(ACCESS_KEY); } catch { return null; }
};
export const getRefreshToken = () => {
  try { return localStorage.getItem(REFRESH_KEY); } catch { return null; }
};
export const setTokens = (access, refresh) => {
  try {
    if (access) localStorage.setItem(ACCESS_KEY, access);
    else localStorage.removeItem(ACCESS_KEY);
    if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
    else if (refresh === null) localStorage.removeItem(REFRESH_KEY);
  } catch {}
};
export const clearTokens = () => {
  try {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  } catch {}
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-refresh on 401 (one retry)
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    const url = original.url || "";
    if (
      status === 401 &&
      !original._retry &&
      !url.includes("/auth/login") &&
      !url.includes("/auth/register") &&
      !url.includes("/auth/refresh") &&
      getRefreshToken()
    ) {
      original._retry = true;
      try {
        if (!refreshing) {
          refreshing = axios
            .post(`${API}/auth/refresh`, { refresh_token: getRefreshToken() })
            .then(({ data }) => {
              setTokens(data.access_token, undefined);
              return data.access_token;
            })
            .finally(() => { refreshing = null; });
        }
        const newToken = await refreshing;
        original.headers = original.headers || {};
        original.headers.Authorization = `Bearer ${newToken}`;
        return api(original);
      } catch {
        clearTokens();
      }
    }
    return Promise.reject(error);
  },
);

export const resolveImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `${BACKEND_URL}${url}`;
};

// Prefer thumbnail for feed/hover images when available
export const resolveThumbUrl = (photo) => {
  return resolveImageUrl(photo?.thumb_url || photo?.image_url || "");
};

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
